import Element from "../components/base/element";

export default class WidgetSearchField extends Element {
	constructor(props) {
		super(props);
		this.$input = null;
		this.$action = null;

		this.unsetActiveStateOnBlur = props.unsetActiveStateOnBlur === null || props.unsetActiveStateOnBlur === undefined
			? true : props.unsetActiveStateOnBlur;
		this.activeStateOnFocus = props.activeStateOnFocus == null ? false : props.activeStateOnFocus;
		this.dropStateOnAction = props.dropStateOnAction == null ? false : props.dropStateOnAction;
		this.action = props.action || null;
		this.value = '';

		this.SEARCH_INPUT_EVENT = 'searchInput';
		this.ACTIVE_STATE_EVENT = 'activeState';
		this.DROP_STATE_EVENT = 'dropState';
		this.INPUT_FOCUS_EVENT = 'inputFocus';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('WidgetSearchField: Root element is not defined.');
		}

		this.$input = this.$root.querySelector('.widget-search-field_input');
		this.$action = this.$root.querySelector('.widget-search-field_action');

		super.init();
	}

	addEventListeners() {
		if (this.unsetActiveStateOnBlur === false) {
			/* Set active state */
			this.$input.addEventListener('click', (e) => {
				this.setActiveState();
			});
		}

		/* Handle text input */
		this.$input.addEventListener('input', (e) => {
			this.value = e.target.value.trim();

			if (this.unsetActiveStateOnBlur) {
				if (this.value.length) {
					this.$root.classList.add('-filled');
				} else {
					this.$root.classList.remove('-filled');
				}
			}

			this.dispatchEvent(this.SEARCH_INPUT_EVENT, this.value);
		});

		this.$input.addEventListener('focus', () => {
			if (this.activeStateOnFocus) {
				this.setActiveState();
			}
			this.dispatchEvent(this.INPUT_FOCUS_EVENT);
		});

		/* Handle action btn click */
		this.$action.addEventListener('click', (e) => {
			if (this.action && typeof this.action === 'function') {
				this.action(this.value);
			} else {
				this.dropState();
			}
		});

		if (this.action && typeof this.action === 'function') {
			this.$input.addEventListener('keydown', (e) => {
				if (e.key === 'Enter') {
					this.action(this.value);
				}
			});
		}
	}

	setActiveState() {
		this.$root.classList.add('-active');
		this.dispatchEvent(this.ACTIVE_STATE_EVENT);
	}

	dropState() {
		this.value = '';
		this.$input.value = '';
		this.$input.dispatchEvent(new Event('input'));

		if (this.unsetActiveStateOnBlur === false || this.dropStateOnAction) {
			this.$root.classList.remove('-active');
		}

		this.dispatchEvent(this.DROP_STATE_EVENT);
	}
}